<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h5><span style="padding-right:15px"></span> <i class="fa fa-cogs"></i><b> Manage {{this.lblHeading}}</b></h5>
    </div>
  </div>
  <hr>
  <div class="row">
    <div *ngIf="isRemove" class="text-danger col-md-12">
      <input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
      <button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
      <button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
    </div>
    <div class="col-md-12" *ngIf="!isRemove">
    
      <p-table #tbpTypes [value]="pTypes"
      [rows]="10"  [rowsPerPageOptions]="[10,25,50]"  styleClass="p-datatable-customers"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0">
       <!-- [globalFilterFields]="['code','description','current_application_fee','sort_order']">
        <ng-template pTemplate="caption">
            <div class="table-header">
             
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="tbpTypes.filterGlobal($event.target.value, 'contains')" placeholder="Global Search" />
                </span>
            </div>
        </ng-template> -->
        <ng-template pTemplate="header">
          <tr>
            <th >Code</th>
            <th style="word-wrap: break-word">Description</th>
            <th style="word-wrap: break-word">Temp or Long-term</th>
            <th style="word-wrap: break-word">Freight or Passenger</th>
            <th style="word-wrap: break-word">App Fee</th>
            <th style="word-wrap: break-word">Permit Fee</th>
            <!-- <th style="word-wrap: break-word">Period</th> -->
            <th style="word-wrap: break-word">Active?</th>
            <!-- <th style="word-wrap: break-word">Sort Order</th> -->
            <!-- <th style="word-wrap: break-word"> Group </th> -->
            <!-- <th style="word-wrap: break-word">Display</th> -->
         
            <!-- Removed from the view table
            <th style="word-wrap: break-word">Prod Link</th>
           <th style="word-wrap: break-word">App Prod Link</th>
         <th style="word-wrap: break-word">Is Permit</th>
         <th style="word-wrap: break-word">Renewal Number</th>
         <th style="word-wrap: break-word">Replace Vehicle?</th>
         <th style="word-wrap: break-word">Amend Route</th>
         <th style="word-wrap: break-word">Amend Timetable</th> -->

         <!-- <th style="word-wrap: break-word">
           Association 
          </th>
         <th style="word-wrap: break-word">
            Own Vehicle
          </th> -->

         <!-- Removed from the view table 
         <th style="word-wrap: break-word">Timetable</th>
         <th style="word-wrap: break-word">Annual Compliance</th> -->

         <!-- <th style="word-wrap: break-word">
           Month Returns
          </th> -->
          <!-- <th style="word-wrap: break-word">
          Specify Duration
           </th> -->
           <!-- <th style="word-wrap: break-word">
            Charge When
             </th> -->
          
            <th>
              <a [routerLink]="['/permit/type/add']">
                <div class='text-center'><span title="Add a New Permit Type" class=" btn-add btn btn-primary btn-sm brd"><i class="fa fa-plus fa-2x" aria-hidden="true"></i></span></div>
              </a>
            </th>
          </tr>
          <tr>
            <th>
                <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'code', 'contains')" placeholder="Code" class="form-control">
            </th>
            <th>
                 <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'description', 'contains')" placeholder="Description" class="form-control">
            </th>
            <th>
              <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'temp_long_ind', 'contains')" placeholder="1 = Temp or 2 = Long-term" class="form-control">
            </th>
            <th>
              <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'freight_passenger_ind', 'contains')" placeholder="Freight or Passenger" class="form-control">
            </th>
            <th>
              <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'current_application_fee', 'contains')" placeholder="App Fees" class="form-control">
            </th>
            <th>
              <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'current_fee', 'contains')" placeholder="Perm Fees" class="form-control">
            </th>
            <!-- <th>
              <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'name', 'startsWith')" placeholder="Search by Name" class="form-control">
          </th> -->
          <th>
              <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'is_active', 'contains')" placeholder="Is Active" class="form-control">
          </th>
          <!-- <th>
            <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'sort_order', 'contains')" placeholder="Sort Order" class="form-control">
          </th>
          <th>
             <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'group_code', 'contains')" placeholder="Group" class="form-control">
          </th>
          <th>
            <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'display_ind', 'contains')" placeholder="Display" class="form-control">
          </th> -->

          <!--Removed from the view table
          <th>
            <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'product_link', 'contains')" placeholder="Product Link" class="form-control">
          </th>
          <th>
            <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'application_product_link', 'contains')" placeholder="Product Link" class="form-control">
          </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'is_permit', 'contains')" placeholder="Is Permit" class="form-control">
        </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'num_renewals_allowed', 'contains')" placeholder="Renewal Number" class="form-control">
        </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'can_replace_vehicle', 'contains')" placeholder="Replace Vehicle?" class="form-control">
        </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'can_amend_route', 'contains')" placeholder="Amend Route?" class="form-control">
        </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'can_amend_timetable', 'contains')" placeholder="Amend Timetable?" class="form-control">
        </th> -->

        <!-- <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'association_reqd', 'contains')" placeholder="Association Required?" class="form-control">
        </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'own_vehicle_reqd', 'contains')" placeholder="Own Vehicle" class="form-control">
        </th> -->

        <!-- Removed from the view table
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'timetable_reqd', 'contains')" placeholder="Timetable" class="form-control">
        </th>
        <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'annual_compliance_reqd', 'contains')" placeholder="Annaul Compliance" class="form-control">
        </th>-->

        <!-- <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'monthly_return_reqd', 'contains')" placeholder="Monthly Return" class="form-control">
        </th>   -->
        <!-- <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'can_specify_duration', 'contains')" placeholder="Specify Duration" class="form-control">
        </th> -->
        <!-- <th>
          <input pInputText type="text" (input)="tbpTypes.filter($event.target.value, 'charge_when_ind', 'contains')" placeholder="Charge When" class="form-control">
        </th>  -->
        <th style="text-align: center;">
          Edit/Delete
        </th>    
        </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pType>
            <tr>
              <td class="bfr-end-col">{{pType.code}}</td>
              <td class="bfr-end-col">{{pType.description}}</td>
              <td class="bfr-end-col">{{showIndicator(pType.temp_long_ind,2)}}</td>
              <td class="bfr-end-col">{{showIndicator(pType.freight_passenger_ind)}}</td>
              <td class="bfr-end-col">{{(pType.current_application_fee)? (pType.current_application_fee | currencyFormat):'R0'}}</td>
              <td class="bfr-end-col">{{(pType.current_fee)? (pType.current_fee| currencyFormat):'R0'}}</td>
              <!-- <td class="bfr-end-col">{{showPeriod(pType)}}</td> -->
              <td class="bfr-end-col">{{utility.isActive(pType.is_active)}}</td>
              <!-- <td class="text-center bfr-end-col">{{pType.sort_order}}</td>
              <td class="text-center bfr-end-col">{{pType.group_code}}</td>
              <td class="bfr-end-col">{{utility.showDisplayIndicator(pType.display_ind)}}</td> -->
              <!-- Removed from the view table
              <td class="text-center bfr-end-col">{{pType.product_link}}</td>
              <td class="text-center bfr-end-col">{{pType.application_product_link}}</td>
              <td class="text-center bfr-end-col">{{pType.is_permit}}</td>
              <td class="text-center bfr-end-col">{{pType.num_renewals_allowed}}</td>
              <td class="text-center bfr-end-col">{{pType.can_replace_vehicle}}</td>
              <td class="text-center bfr-end-col">{{pType.can_amend_route}}</td>
              <td class="text-center bfr-end-col">{{pType.can_amend_timetable}}</td>-->

              <!-- <td class="text-center bfr-end-col">{{pType.association_reqd}}</td> -->
              <!-- <td class="text-center bfr-end-col">{{pType.own_vehicle_reqd}}</td> -->

              <!-- Removed from the view table
              <td class="text-center bfr-end-col">{{pType.timetable_reqd}}</td>
              <td class="text-center bfr-end-col">{{pType.annual_compliance_reqd}}</td>-->

              <!-- <td class="text-center bfr-end-col">{{pType.monthly_return_reqd}}</td> -->
              <!-- <td class="text-center bfr-end-col">{{pType.can_specify_duration}}</td> -->
              <!-- <td class="text-center bfr-end-col">{{pType.charge_when_ind}}</td> -->
                           <td class="btn-show bfr-end-col end-col">
                <a [routerLink]="['/permit/type/edit',pType.id]"><span title="Edit Permit Type" style="margin: 0%" class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a>
                <span title="Delete Permit Type" style="margin: 0%" class="btn btn-danger btn-sm" (click)="onConfirm(pType)"><i class="fa fa-trash-o fa-fw"></i></span>
              </td>
            </tr>
        </ng-template>
         </p-table>


      <!-- <table id="vTypes" border="1" class="table tbl-stl">
        <thead class="thead-inverse hgt-btn">
          <tr style="vertical-align:middle;" class="hgt-btn">
            <th style="vertical-align:middle;width:100px;padding:0px;" class="bfr-end-col">
              Code
              <i class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
                 (click)="utility.onSort(1)"></i>
            </th>
            <th style="vertical-align:middle;margin:0px;padding:0px;" class="bfr-end-col">
              Description
              <i style="vertical-align:middle;" class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
                 (click)="utility.onSort(2)"></i>
            </th>
            <th style="vertical-align:middle;width:100px!important;padding:0px;" class="bfr-end-col">Temp or Long-term</th>
            <th style="vertical-align:middle;width:100px!important;padding:0px;" class="bfr-end-col">Freight or Passenger</th>
            <th style="vertical-align:middle;width:100px!important;padding:0px;" class="bfr-end-col">Application Fee</th>
            <th style="vertical-align:middle;width:100px!important;padding:0px;" class="bfr-end-col">Permit Fee</th>
            <th style="vertical-align:middle;width:100px!important;padding:0px;" class="bfr-end-col">Period</th>
            <th style="vertical-align:middle;width:80px!important;padding:0px;" class="bfr-end-col">
              Active?
              <i class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
                 (click)="utility.onSort(3)"></i>
            </th>
            <th style="vertical-align:middle;width:100px;padding:0px;" class="bfr-end-col">
              Sort Order
              <i class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
                 (click)="utility.onSort(5)"></i>
            </th>
            <th style="vertical-align:middle;width:60px!important;padding:0px;" class="bfr-end-col">
              Group
              <i class="fa" [ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
                 (click)="utility.onSort(4)"></i>
            </th>
            <th style="vertical-align:middle;padding:0px;" class="bfr-end-col">Display</th>
            <th class="btn-show hgt-btn bfr-end-col end-col">
              <a [routerLink]="['/permit/type/add']">
                <span title="Add a New Permit Type" class=" btn-add btn btn-primary btn-sm brd"><i class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
              </a>
            </th>
          </tr>
        </thead>
        <tr style="height: 10px !important;" *ngFor="let pType of pTypes  | orderBy:utility.criteria: utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
          <td class="bfr-end-col">{{pType.code}}</td>
          <td class="bfr-end-col">{{pType.description}}</td>
          <td class="bfr-end-col">{{showIndicator(pType.temp_long_ind,2)}}</td>
          <td class="bfr-end-col">{{showIndicator(pType.freight_passenger_ind)}}</td>
          <td class="bfr-end-col">{{(pType.current_application_fee)? (pType.current_application_fee | currencyFormat):'R0'}}</td>
          <td class="bfr-end-col">{{(pType.current_fee)? (pType.current_fee| currencyFormat):'R0'}}</td>
          <td class="bfr-end-col">{{showPeriod(pType)}}</td>
          <td class="bfr-end-col">{{utility.isActive(pType.is_active)}}</td>
          <td class="text-center bfr-end-col">{{pType.sort_order}}</td>
          <td class="text-center bfr-end-col">{{pType.group_code}}</td>
          <td class="bfr-end-col">{{utility.showDisplayIndicator(pType.display_ind)}}</td>
          <td class="btn-show bfr-end-col end-col">
            <a [routerLink]="['/permit/type/edit',pType.id]"><span title="Edit Permit Type" style="margin: 0%" class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a>
            <span title="Delete Permit Type" style="margin: 0%" class="btn btn-danger btn-sm" (click)="onConfirm(pType)"><i class="fa fa-trash-o fa-fw"></i></span>
          </td>
        </tr>
        <tfoot>
          <tr *ngIf="pTypes.length > 4" style="padding-left:0px;margin-left:0px;">
            <td colspan="8" class="rm-brd" style="padding-left:0px;margin-left:0px;">
              <div class="row">
                <div class="col-2">
                  <div class="input-group mb-3 rm-brd" style="width:125px!important;height:30px!important;">
                    <div class="input-group-prepend">
                      <label class="input-group-text form-control-sm show-h" for="show-id" style="">Show:</label>
                    </div>
                    <select class="form-control form-control-sm show-h" id="show-id" [(ngModel)]="showNum" style="">
                      <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-8 text-center">
                  <pagination-controls (pageChange)="utility.page = $event" style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
                </div>
              </div>
            </td>
          </tr>
          <tr *ngIf="isEmpty">
            <td colspan="4" class="rm-brd">
              <span class="text-info text-small">No Permit Types found.</span>
            </td>
          </tr>
        </tfoot>
      </table> -->
    </div>
  </div>
</div>
